export default __webpack_public_path__ + "6af9a737cff4ce27a2215464d80dbfbc.png";